var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_3176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 11.6875L5.84375 9.03125L4.78125 10.0938L4.25 12.75L7.96875 11.6875Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1533 0.84701C15.0226 -0.283656 13.1829 -0.283622 12.0522 0.84701L4.72886 8.17042C4.65637 8.24291 4.60644 8.33478 4.58499 8.43499L3.67393 12.6948C3.63627 12.871 3.69043 13.0542 3.8178 13.1816C3.91847 13.2823 4.05407 13.3373 4.19349 13.3373C4.23044 13.3373 4.26766 13.3334 4.30459 13.3255L8.56534 12.4144C8.66558 12.393 8.75746 12.3431 8.82994 12.2706L16.1532 4.94736C16.6992 4.40177 17 3.67366 17 2.89707C17 2.12052 16.6992 1.39241 16.1533 0.84701ZM5.41975 9.6127L7.38683 11.5798L4.88458 12.1149L5.41975 9.6127ZM15.402 4.19578L8.45378 11.144L5.85594 8.54612L12.8036 1.5984C13.52 0.88204 14.6856 0.88204 15.4021 1.5986C15.7473 1.94341 15.9374 2.40454 15.9374 2.89707C15.9374 3.38961 15.7473 3.8508 15.402 4.19578ZM14.3352 9.43367V15.0159C14.3352 16.1101 13.445 17.0004 12.3508 17.0004H1.98355C0.889811 17.0004 0 16.1101 0 15.0159V4.6496C0 3.55532 0.889811 2.66508 1.98355 2.66508H7.56576C7.85918 2.66508 8.09705 2.90295 8.09705 3.19636C8.09705 3.48978 7.85918 3.72765 7.56576 3.72765H1.98355C1.47575 3.72765 1.0626 4.14123 1.0626 4.64957V15.0158C1.0626 15.5242 1.47575 15.9377 1.98355 15.9377H12.3508C12.8591 15.9377 13.2727 15.5242 13.2727 15.0158V9.43367C13.2727 9.14025 13.5105 8.90239 13.8039 8.90239C14.0974 8.90239 14.3352 9.14022 14.3352 9.43367Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_3176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.84e646bbd232ca86d3a59d0ccbab06e1.svg";
export { ForwardRef as ReactComponent };